module.exports = __webpack_public_path__ + "assets/static/images/popup/iphone-frame.png";